import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { tokenExpiry } from './helpers/getUserInfo';
import { useLogout } from './hooks/use-logout';
import { Sidebar } from './layouts/Sidebar';
import routes from './routes/routes';
import { useAuth } from './hooks/use-auth';

function App() {
  const expire = tokenExpiry();
  const renderRoutes = useRoutes(routes);
  const { handleSignOutWithApi } = useLogout();
  const { isError, data, isFetching } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);

    if (expire && expire * 1500 < Date.now()) {
      handleSignOutWithApi();
      return;
    }

    if (isError && data === undefined && !isFetching) {
      handleSignOutWithApi();
    }
  }, [expire, isError, data, isFetching]);

  return (
    <div className="App">
      <Sidebar>{renderRoutes}</Sidebar>
    </div>
  );
}

export default App;
